import { useMemo } from 'react';
import getCarrierFields from '../helpers/getCarrierFields';

const useCarrierFields = carrierType => useMemo(() => ({
  accountNumber: getCarrierFields(carrierType, 'accountNumber'),
  key: getCarrierFields(carrierType, 'key'),
  secretKey: getCarrierFields(carrierType, 'secretKey'),
  password: getCarrierFields(carrierType, 'password'),
  batchShipping: getCarrierFields(carrierType, 'batchShipping'),
  meter: getCarrierFields(carrierType, 'meter'),
  mode: getCarrierFields(carrierType, 'mode'),
  smartPost: getCarrierFields(carrierType, 'smartPost'),
  trackingApiKeys: getCarrierFields(carrierType, 'trackingApiKeys'),
}), [carrierType]);

export default useCarrierFields;
